module.exports = __webpack_public_path__ + "img/horizontal_4_3_pp3_7042.5a4c3ec3.png";